import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import blockService from './blockService';

const initialState = {
  youtubeBlock: '',
  isYoutubeBlockError: false,
  isYoutubeBlockSuccess: false,
  isYoutubeBlockLoading: false,
  isYoutubeBlockErrorMsg: '',
};

export const creatingYoutubeBlock = createAsyncThunk(
  'youtubeBlock/creatingYoutubeBlock',

  async (headingkData, thunkAPI) => {
    try {
      const response = await blockService.creatingHeadingBlock(headingkData);
      return response;
    } catch (error) {
      const isYoutubeBlockErrorMsg =
        (error.response && error.response.data && error.response.data.isYoutubeBlockErrorMsg) ||
        error.isYoutubeBlockErrorMsg ||
        error.toString();
      return thunkAPI.rejectWithValue(isYoutubeBlockErrorMsg);
    }
  }
);

export const youtubeSlice = createSlice({
  name: 'youtubeBlock',
  initialState,
  reducers: {
    resetUser: (state) => {
      state.isYoutubeBlockLoading = false;
      state.isYoutubeBlockSuccess = false;
      state.isYoutubeBlockError = false;
      state.isYoutubeBlockErrorMsg = '';
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(creatingYoutubeBlock.pending, (state) => {
        state.isYoutubeBlockLoading = true;
      })
      .addCase(creatingYoutubeBlock.fulfilled, (state, action) => {
        state.isYoutubeBlockLoading = false;
        state.isYoutubeBlockSuccess = true;
        state.youtubeBlock = action.payload;
      })
      .addCase(creatingYoutubeBlock.rejected, (state, action) => {
        state.isYoutubeBlockLoading = false;
        state.isYoutubeBlockError = true;
        state.isYoutubeBlockErrorMsg = action.payload; // error from catch will come here via action.payload and update isYoutubeBlockErrorMsg
      });
  },
});

export const { resetUser } = youtubeSlice.actions;
export default youtubeSlice.reducer;
